import { AnimatePresence } from "motion/react";
import { FC } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { AccessControl } from "@ryde/controls";
import { AnimatedPage, JourneyEdit } from "@ryde/layout";
import { RydeUiUnit } from "@ryde/shared";

export const JourneyCrudRoutes: FC = () => {
  const entity: RydeUiUnit = "journey";
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="new"
          element={
            <AccessControl entity={entity} action="create">
              <AnimatedPage>
                <JourneyEdit isAddRoute />
              </AnimatedPage>
            </AccessControl>
          }
        ></Route>
        <Route
          path="add"
          element={
            <AccessControl entity={entity} action="create">
              <AnimatedPage>
                <JourneyEdit isAddRoute />
              </AnimatedPage>
            </AccessControl>
          }
        ></Route>
        <Route
          path="add/:id"
          element={
            <AccessControl entity={entity} action="update">
              <AnimatedPage>
                <JourneyEdit isAddRoute />
              </AnimatedPage>
            </AccessControl>
          }
        ></Route>
        <Route
          path="edit/:id"
          element={
            <AccessControl entity={entity} action="read">
              <AnimatedPage>
                <JourneyEdit />
              </AnimatedPage>
            </AccessControl>
          }
        ></Route>
      </Routes>
    </AnimatePresence>
  );
};
